export default __webpack_public_path__ + "static/media/logo.a0c4e74a.png";